import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "objective-c",
  extensions: [".m"],
  aliases: ["Objective-C"],
  loader: () => import('./objective-c.js')
});
